/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import SettingsWorkspaceIdentifiersBase from 'cio/components/settings/workspace-identifiers/base';

export default class SettingsWorkspaceIdentifiersCioId extends SettingsWorkspaceIdentifiersBase {}
